import { render, staticRenderFns } from "./iconAddAddresses.vue?vue&type=template&id=076eb827&scoped=true"
import script from "./iconAddAddresses.vue?vue&type=script&lang=js"
export * from "./iconAddAddresses.vue?vue&type=script&lang=js"
import style0 from "./iconAddAddresses.vue?vue&type=style&index=0&id=076eb827&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076eb827",
  null
  
)

export default component.exports